import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Link, useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { isNative } from "@/lib/platform";

const CookieBanner = () => {
    const [showBanner, setShowBanner] = useState(() => {
        if (typeof window === "undefined" || isNative()) return false;
        try {
            return !localStorage.getItem("cookie_consent_accepted");
        } catch {
            return false;
        }
    });
    const location = useLocation();

    // Define public routes where the cookie banner is relevant
    const publicRoutes = ['/', '/privacy', '/terms', '/refund', '/refund-policy', '/cookie-policy', '/features'];
    const isPublicRoute = publicRoutes.includes(location.pathname.toLowerCase());

    const handleAccept = () => {
        localStorage.setItem("cookie_consent_accepted", "true");
        setShowBanner(false);
    };

    if (!showBanner || !isPublicRoute) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 animate-in slide-in-from-bottom-full duration-500">
            <div className="max-w-4xl mx-auto bg-card border border-border shadow-2xl rounded-2xl p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 relative overflow-hidden">
                <div className="absolute inset-0 bg-primary/5 pointer-events-none" />
                
                <div className="relative pr-6">
                    <h3 className="font-bold text-foreground mb-1">We value your privacy</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                        We use cookies and similar technologies to enhance your browsing experience, serve personalized content, and analyze our traffic. 
                        By clicking "Accept", you consent to our use of cookies.
                    </p>
                    <Link to="/privacy-policy" className="text-sm text-primary font-medium hover:underline inline-block mt-2">
                        Read our Privacy Policy
                    </Link>
                </div>

                <div className="flex items-center gap-3 w-full sm:w-auto relative shrink-0">
                    <Button 
                        onClick={handleAccept} 
                        className="w-full sm:w-auto rounded-xl px-8"
                    >
                        Accept
                    </Button>
                    <button 
                        onClick={handleAccept}
                        className="sm:hidden absolute top-[-4.5rem] right-0 p-2 text-muted-foreground hover:text-foreground transition-colors"
                        aria-label="Close banner"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
